import { toast } from 'react-toastify';
import ApiBase from "./base";
import i18n from "../translations";
import { jsonToQueryString } from '../shared/utils';

export const _ROLE_URL = "role";

export async function getRoleList() {
    const response = await ApiBase.get(`${_ROLE_URL}`);

    return response.items;
}

export async function getAdminPortalRoleList() {
    const response = await ApiBase.get(`${_ROLE_URL}/admin`);

    return response.items;
}

export async function getAdminPortalRoleListWithParams(params) {
    const response = await ApiBase.get(`${_ROLE_URL}/admin?${jsonToQueryString(params)}`);

    return response;
}

export async function getPermissionList() {
    const response = await ApiBase.get(`${_ROLE_URL}/permission`);

    return response;
}

export async function createRole(params) {
    const response = await ApiBase.post(`${_ROLE_URL}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_CREATE_ROLE"))

    return response;
}

export async function updateRole(id, params) {
    const response = await ApiBase.patch(`${_ROLE_URL}/${id}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_UPDATE_ROLE"))

    return response;
}